import WrapperService from "@/modules/core/services/wrapper-service";
import { createPageableParams } from "@/modules/core/services/table-utils";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/tasklist"
const serviceName = "TaskList-Service: ";

export default class TaskListService {
  // Task List Requests for facility
  static async readPageableFacilityTaskListFromAPI(facilityId, page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/facility/" + facilityId + "?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableFacilityOpenTaskListFromAPI(facilityId, page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/facility/" + facilityId + "/open?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableFacilityProcessFinishedFromAPI(facilityId, page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/facility/" + facilityId + "/finished?" + params, period, serviceName, successF, errorF);
  }


  // Task List Requests for building
  static async readPageableBuildingTaskListFromAPI(buildingId, page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/building/" + buildingId + "?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableBuildingOpenTaskListFromAPI(buildingId, page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/building/" + buildingId + "/open?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableBuildingProcessFinishedFromAPI(buildingId, page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/building/" + buildingId + "/finished?" + params, period, serviceName, successF, errorF);
  }


  // Task List Requests for process page
  static async readPageableCustomerTaskListFromAPI(page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/processes?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableCustomerProcessInvitationsFromAPI(page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/processes/invitations?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableCustomerRolesInvitationsFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.get(API_URL + "/processes/roles", { params: params }, serviceName, successF, errorF);
  }

  static async readPageableCustomerInvitationsromAPI(page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/processes/all-invitations?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableCustomerProcessAssignmentsFromAPI(page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/processes/assigned?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableCustomerProcessFinishedFromAPI(page, size, search, sort, sortAsc, period, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.put(API_URL + "/processes/finished?" + params, period, serviceName, successF, errorF);
  }

  static async readPageableCustomerProcessThisWeekFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.get(API_URL + "/processes/week", { params: params }, serviceName, successF, errorF);
  }

  static async countFinishedProcess(successF, errorF) {
    await WrapperService.get(API_URL + "/processes/count/finished", null, serviceName, successF, errorF);
  }

  static async countOpenProcess(successF, errorF) {
    await WrapperService.get(API_URL + "/processes/count/open", null, serviceName, successF, errorF);
  }

  static async countInvitations(successF, errorF) {
    await WrapperService.get(API_URL + "/processes/count/invitation", null, serviceName, successF, errorF);
  }

  static async countThisWeek(successF, errorF) {
    await WrapperService.get(API_URL + "/processes/count/week", null, serviceName, successF, errorF);
  }
}